module.exports = __webpack_public_path__ + "d2d78794297072dd1f4ea2e75806480b.pdf";